import React from "react";
import { useBooleanState } from "../../../hooks";
import { ConfirmModalProps } from "./ConfirmModal.types";
import { ConfirmModal } from "./index";

const VeriModalWrapper = (
  isOpen: boolean,
  onClose: () => void,
  props?: Partial<ConfirmModalProps>,
) => {
  const VeriModalWrapperFC: React.FC<Partial<ConfirmModalProps>> = ({
    ...rest
  }) => {
    return isOpen ? (
      <ConfirmModal
        isOpen={isOpen}
        onClose={rest.onClose || onClose}
        {...props}
        {...rest}
      />
    ) : (
      <></>
    );
  };

  return VeriModalWrapperFC;
};

export function useVeriConfirmModal(
  props?: Partial<ConfirmModalProps>,
  initialOpen?: boolean,
) {
  const isOpen = useBooleanState(initialOpen || false);

  return {
    Modal: VeriModalWrapper(isOpen.state, isOpen.false.bind(null), props),
    open: isOpen.true.bind(null),
    close: isOpen.false.bind(null),
    toggle: isOpen.toggle.bind(null),
  };
}
